import {
  CheckCircle,
  Description,
  PersonAdd,
  Send,
  Visibility,
} from "@mui/icons-material";

export const METRIC_TITLES = {
  Envoi: "Liste des envois",
  Révélation: "Liste des révélations",
  Propale: "Liste des propales",
  Signature: "Liste des signatures",
  Sourcing: "Liste des sourcés",
};

export const METRIC_CONFIG = {
  Sourcing: {
    Icon: PersonAdd,
    color: "#0f9688",
    bgColor: "#e0f2f1",
    chipLabel: "Sourcé",
  },
  Envoi: {
    Icon: Send,
    color: "#1976d2",
    bgColor: "#e3f2fd",
    chipLabel: "Envois",
  },
  Révélation: {
    Icon: Visibility,
    color: "#7b1fa2",
    bgColor: "#f3e5f5",
    chipLabel: "Révélations",
  },
  Propale: {
    Icon: Description,
    color: "#f59e0b",
    bgColor: "#fffde7",
    chipLabel: "Propales",
  },
  Signature: {
    Icon: CheckCircle,
    color: "#16a34a",
    bgColor: "#e8f5e9",
    chipLabel: "Signatures",
  },
};

export const STEP_COLORS = {
  Envoi: { bg: "#e3f2fd", color: "#1565c0" },
  Révélation: { bg: "#f3e5f5", color: "#6a1b9a" },
  Propale: { bg: "#fff8e1", color: "#b45309" },
  "Embauche/Integration": { bg: "#e8f5e9", color: "#2e7d32" },
  RDV: { bg: "#e0f7fa", color: "#00695c" },
  "Changement de date": { bg: "#fce4ec", color: "#880e4f" },
};

export const AVATAR_COLORS = ["#1976d2", "#0f9688", "#7b1fa2", "#ef5350"];
export const BORDER = "0.5px solid rgba(0,0,0,0.15)";
export const ROWS_PER_PAGE = 30;

export const getInitials = (nom, prenom) => {
  const f = (prenom || "").charAt(0).toUpperCase();
  const l = (nom || "").charAt(0).toUpperCase();
  return `${f}${l}` || "?";
};
